import React, {useState, useEffect} from "react"
import MFA from "@irati/auth/utils/mfa"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import RequestMfa from "./request"
import SMSSetup from "./sms/Setup"
import TOTPSetup from "./totp/Setup"
import SMSEnterCode from "./sms/EnterCode"
import TOTPEnterCode from "./totp/EnterCode"

export enum Screens {
  REQUEST = "REQUEST",
  SMS_SETUP = "SMS_SETUP",
  SMS_ENTER = "SMS_ENTER",
  TOTP_SETUP = "TOTP_SETUP",
  TOTP_ENTER = "TOTP_ENTER"
}

export type ModalState = {[key in Screens]: boolean} & {previous: Screens}

const modals = [Screens.REQUEST, Screens.SMS_SETUP, Screens.TOTP_SETUP, Screens.SMS_ENTER, Screens.TOTP_ENTER]

export interface ExtraData {
  /** @description As part of the setup flow, a request is already sent, SMS_ENTER does not want to re-request */
  smsAlreadyRequested?: boolean
}

export type SelectScreen = (screen: Screens | null, extraData?: ExtraData) => void

interface Props {}

const MFAPopup: React.FC<Props> = () => {
  const [screen, setScreen] = useState(modalStory<Screens>(modals, null))
  const [extraData, setExtraData] = useState<ExtraData>({})

  useEffect(() => {
    MFA.addEventListener(handleMFAStateChange)
    return () => {
      MFA.removeEventListener(handleMFAStateChange)
    }
  }, [])

  const handleMFAStateChange = () => {
    selectScreen(Screens.REQUEST)
  }

  const selectScreen: SelectScreen = (s, d = {}) => {
    setExtraData(d)
    setScreen(modalStory(modals, s))
  }

  const handleCancel = () => {
    MFA.cancel()
    selectScreen(null)
  }

  if (!anyStoriesOpen(screen)) {
    return null
  }

  return (
    <>
      <RequestMfa show={screen[Screens.REQUEST]} onCancel={handleCancel} selectScreen={selectScreen} />
      <SMSSetup show={screen[Screens.SMS_SETUP]} onCancel={handleCancel} selectScreen={selectScreen} />
      <TOTPSetup show={screen[Screens.TOTP_SETUP]} onCancel={handleCancel} selectScreen={selectScreen} />
      <SMSEnterCode show={screen[Screens.SMS_ENTER]} onCancel={handleCancel} selectScreen={selectScreen} extraData={extraData} />
      <TOTPEnterCode show={screen[Screens.TOTP_ENTER]} onCancel={handleCancel} selectScreen={selectScreen} />
    </>
  )
}

export default MFAPopup
